import { Badge, SxProps, Theme } from "@mui/material"
import { ElementType, HTMLAttributes, ReactNode } from "react"
import { ReactSVG } from "react-svg"
import { twMerge } from "tailwind-merge"

interface ElementProps extends HTMLAttributes<HTMLDivElement> {
    icon?: ElementType,
    badge?: ElementType,
    badgeSx?: SxProps<Theme>,
    badgeMarker?: any,
    sxProps?: SxProps<Theme>,
    colorProp?: string,
    sizeProp?: string,
    children?: ReactNode
}

interface SvgProps {
    iconSrc: string;
    color: string;
    className?: string;
    title?: string;
};

export function Svg({ iconSrc, color, className }: SvgProps) {
    return (
        <ReactSVG 
            src={iconSrc}
            beforeInjection={(svg) => {
                svg.setAttribute('style', `fill: ${color}`);
            }}
            afterInjection={(svg) => {
                svg.setAttribute('style', `fill: ${color}`);
            }}
            className={twMerge("", className)}
        />
    )
}